<div class="relative scroll h-full max-h-[95vh] xs:p-6 p-12">
  <h2 class="mb-5 text-center capitalize">{{ data.title | translate }}</h2>
  <p class="text-justify" #textArea>{{ text }}</p>
</div>

<!-- Close button -->
<button
  mat-icon-button
  class="absolute top-0 right-0 xs:m-3 m-5"
  (click)="MD_REF.close()">
  <mat-icon class="icon-size-17 fa-regular fa-xmark"></mat-icon>
</button>
